export default "__VITE_ASSET__BvuRj2SN__"